import { OFFSET_COUNT_LOAD_PROFILE_HISTORY } from '@/common/constants/count'

export const DEFAULT_HISTORY_PARAMS = {
  limit: OFFSET_COUNT_LOAD_PROFILE_HISTORY,
  offset: 0,
}
